export default __webpack_public_path__ + "static/media/sm-whale.0da092e3.svg";